import React, { useEffect, useState } from "react";
import { Table } from "antd";
import { useNavigate, useParams } from "react-router-dom";
import { getUserLoginHistory } from "../../../apis/usersApis";

const LoginHistory = () => {
  const [loginHistory, setLoginHistory] = useState([]);
  const [loading, setLoading] = useState(true);
  const { id } = useParams();
  const [filters, setFilters] = useState({
    from: "",
    to: "",
  });
  const navigate = useNavigate();
  useEffect(() => {
    fetchLoginHistory(id);
  }, [id]);

  const fetchLoginHistory = async (id, filters = {}) => {
    try {
      const res = await getUserLoginHistory(id, filters);
      console.log("Login History Response:", res.result);
      setLoginHistory(res.result);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching Login History:", error);
      setLoading(false);
    }
  };
  const backClick = () => {
    navigate("/usersList");
  };
  const onSearch = () => {
    fetchLoginHistory(id, filters);
  };
  const onClear = () => {
    const cleared = {
      from: "",
      to: "",
    };
    setFilters(cleared);
    fetchLoginHistory(id, {});
  };

  const columns = [
    {
      title: "S.No",
      dataIndex: "key",
      render: (text, record, index) => <span>{index + 1}</span>,
      width: "10%",
    },

    {
      title: "Name",
      render: (text, record) => {
        return <span>{`${record.firstName} ${record.lastName || ""}`}</span>;
      },
      width: "25%",
    },
    {
      title: "Email",
      dataIndex: "email",
      sorter: (a, b) => a.email.length - b.email.length,
      width: "25%",
    },
    {
      title: "Log In Time",
      dataIndex: "logInTime",
      sorter: (a, b) => new Date(a.logInTime) - new Date(b.logInTime),
      width: "25%",
      render: (value) => {
        if (!value) return "-";

        const date = new Date(value);

        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();

        const hours = String(date.getHours()).padStart(2, "0");
        const minutes = String(date.getMinutes()).padStart(2, "0");

        return `${day}-${month}-${year} -- ${hours}:${minutes}`;
      },
    },
  ];

  return (
    <>
      <div className="main-wrapper">
        <div className="page-wrapper">
          <div className="content container-fluid">
            <i
              className="fas fa-arrow-left"
              style={{ marginRight: "30px", fontSize: "20px" }}
              onClick={backClick}
            />
            {/* <div
              style={{
                display: "flex",
                gap: 10,
                flexWrap: "wrap",
                margin: "15px 0",
              }}
            >
              <input
                type="date"
                className="form-control"
                value={filters.from}
                onChange={(e) =>
                  setFilters({ ...filters, from: e.target.value })
                }
                style={{ width: 200 }}
              />

              <input
                type="date"
                className="form-control"
                value={filters.to}
                onChange={(e) => setFilters({ ...filters, to: e.target.value })}
                style={{ width: 200 }}
              />
              <button className="btn btn-primary" onClick={onSearch}>
                Search
              </button>

              <button className="btn btn-secondary" onClick={onClear}>
                Clear
              </button>
            </div> */}
            {loading ? (
              <div>Loading...</div>
            ) : (
              <Table
                columns={columns}
                dataSource={loginHistory?.length > 0 ? loginHistory : []}
                className="table-striped"
                rowKey={(record) => record.id}
              />
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default LoginHistory;
